import { useContext, useEffect } from 'react'
import {
  WebSocketContext,
  type MessageListener,
  type ReconnectCallback,
} from '../contexts/WebSocketContextBase'

/**
 * WebSocketカスタムフック
 *
 * すべてのコンポーネントは WebSocketProvider が保持する
 * 同じWebSocket接続を共有します。
 */
export function useWebSocket(
  onMessage?: MessageListener,
  onReconnect?: ReconnectCallback
): { connected: boolean; sendMessage: (message: unknown) => boolean; reconnect: () => void } {
  const context = useContext(WebSocketContext)

  if (!context) {
    throw new Error('useWebSocket must be used within a WebSocketProvider')
  }

  const { connected, sendMessage, reconnect, addListener, addReconnectCallback } = context

  // メッセージリスナーの登録
  useEffect(() => {
    if (!onMessage) return

    const unsubscribe = addListener(onMessage)
    return unsubscribe
  }, [onMessage, addListener])

  // 再接続コールバックの登録
  useEffect(() => {
    if (!onReconnect) return

    const unsubscribe = addReconnectCallback(onReconnect)
    return unsubscribe
  }, [onReconnect, addReconnectCallback])

  return {
    connected,
    sendMessage,
    reconnect,
  }
}
